<template>
    <div ref="map" :style="styles" class="map-content">
        <span class="map-loading" v-if="loading">Mapa se se načítá...</span>
    </div>
</template>


<script>
    const markerImage = "https://api.mapy.cz/img/api/marker/drop-red.png";
    export default {
        name: "MapyCz",
        props: {
            width: {
                type: Number,
                default: 600
            },
            height: {
                type: Number,
                default: 400
            },
            from: {
                type: Object,
                default: null
            },
            to: {
                type: Object,
                default: null
            },
            hideRoute: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                map: null,
                mapRouteLayer: null,
                mapRouteGeometry: null,
                mapMarkersLayer: null,
                mapMarkers: []
            }
        },
        computed: {
            styles() {
                return {
                    // width: this.width + 'px',
                    height: this.height + 'px'
                }
            },
            fromCoords() {
                return this.coords(this.from)
            },
            toCoords() {
                return this.coords(this.to)
            }
        },
        watch: {
            from() {
                this.updateRoute();
            }
        },
        methods: {
            coords({longtitude, latitude}) {
                return SMap.Coords.fromWGS84(longtitude, latitude);
            },
            initMap() {
                Loader.async = true;
                Loader.lang = "cs";
                Loader.load(null, {poi: true}, () => {
                    // --- Create map --------------------------------------------------------
                    const m = new SMap(this.$refs.map, this.coords(this.to), 13);
                    m.addDefaultLayer(SMap.DEF_BASE).enable();
                    // --- Add controls ------------------------------------------------------
                    m.addDefaultControls();
                    // --- Dynamic size ------------------------------------------------------
                    var sync = new SMap.Control.Sync({bottomSpace: 30});
                    m.addControl(sync);

                    // --- POI ---------------------------------------------------------------
                    /* znackova vrstva pro ikonky bodu zajmu; poiToolTip - zapneme title jako nazev nad POI */
                    var layer = new SMap.Layer.Marker(undefined, {
                        poiTooltip: true
                    });
                    m.addLayer(layer).enable();
                    /* dataProvider zastiti komunikaci se servery */
                    var dataProvider = m.createDefaultDataProvider();
                    dataProvider.setOwner(m);
                    dataProvider.addLayer(layer);
                    dataProvider.setMapSet(SMap.MAPSET_BASE);
                    dataProvider.enable();

                    // Store map object
                    this.map = m;

                    // Trasa
                    this.updateRoute();
                });
            },
            updateRoute() {
                if (this.hideRoute) {
                    // >> Refactor
                    if (this.mapRouteGeometry) {
                        this.mapRouteLayer.removeGeometry(this.mapRouteGeometry);
                        this.mapRouteGeometry = null;
                    }
                    const coords = [this.fromCoords, this.toCoords];
                    const cz = this.map.computeCenterZoom(coords);
                    this.map.setCenterZoom(cz[0], cz[1]);
                    this.updateMarkers();
                    return;
                    // << Refactor
                }
                // >> Refactor
                const coords2 = [this.fromCoords, this.toCoords];
                const cz = this.map.computeCenterZoom(coords2);
                this.map.setCenterZoom(cz[0], cz[1]);
                // << Refactor

                const nalezeno = (route) => {
                    // Create map layer
                    if (!this.mapRouteLayer) {
                        this.mapRouteLayer = new SMap.Layer.Geometry();
                        this.map.addLayer(this.mapRouteLayer).enable();
                    }

                    const coords = route.getResults().geometry;
                    const cz = this.map.computeCenterZoom(coords);
                    // >> Refactor
                    this.map.setCenterZoom(cz[0], cz[1]);
                    // << Refactor
                    if (this.mapRouteGeometry) {
                        this.mapRouteLayer.removeGeometry(this.mapRouteGeometry);
                    }
                    this.mapRouteGeometry = new SMap.Geometry(SMap.GEOMETRY_POLYLINE, null, coords);
                    this.mapRouteLayer.addGeometry(this.mapRouteGeometry);
                }
                const coords = [this.fromCoords, this.toCoords];

                SMap.Route.route(coords, {
                    geometry: true
                }).then(nalezeno);

                this.updateMarkers();
            },
            updateMarkers() {
                // Remove old markers
                if (this.mapMarkersLayer) {
                    this.map.removeLayer(this.mapMarkersLayer);
                }

                // Create new markers
                this.mapMarkersLayer = new SMap.Layer.Marker();
                const markers = [{
                    name: this.from.name,
                    id: 1,
                    coord: this.fromCoords
                },{
                    name: this.to.name,
                    id: 2,
                    coord: this.toCoords
                }];
                markers.forEach( ({coord, id, name}) => {
                    var znacka = JAK.mel("div");
                    var obrazek = JAK.mel("img", {src:SMap.CONFIG.img+"/marker/drop-red.png"});
                    znacka.appendChild(obrazek);
                    const text = JAK.mel("div", {}, {position:"absolute", left:"5px", top:"6px", textAlign:"center", width:"auto", color:"white", fontWeight:"bold", fontSize: '0.5rem'});
                    text.innerHTML = name.charAt(0);
                    znacka.appendChild(text);
                    const marker = new SMap.Marker(coord, id, {title: name, url: znacka});
                    this.mapMarkersLayer.addMarker(marker);
                    this.mapMarkers.push(marker)
                })

                this.map.addLayer(this.mapMarkersLayer);
                this.mapMarkersLayer.enable();
            },
            onScriptLoaded() {
                Loader.async = true;
                Loader.lang = "cs";
                Loader.load(null, {poi:true}, () => {
                    var center = SMap.Coords.fromWGS84(14.2046206, 50.5996689);
                    var m = new SMap(this.$refs.map, center, 13);
                    m.addDefaultLayer(SMap.DEF_BASE).enable();

                    // Add controls
                    m.addDefaultControls();
                    // Dynamic size
                    var sync = new SMap.Control.Sync({bottomSpace:30});
                    m.addControl(sync);

                    // POI
                    /* znackova vrstva pro ikonky bodu zajmu; poiToolTip - zapneme title jako nazev nad POI */
                    var layer = new SMap.Layer.Marker(undefined, {
                        poiTooltip: true
                    });
                    m.addLayer(layer).enable();
                    /* dataProvider zastiti komunikaci se servery */
                    var dataProvider = m.createDefaultDataProvider();
                    dataProvider.setOwner(m);
                    dataProvider.addLayer(layer);
                    dataProvider.setMapSet(SMap.MAPSET_BASE);
                    dataProvider.enable();

                    // Trasa
                    var nalezeno = function(route) {
                        var vrstva = new SMap.Layer.Geometry();
                        m.addLayer(vrstva).enable();

                        var coords = route.getResults().geometry;
                        var cz = m.computeCenterZoom(coords);
                        m.setCenterZoom(cz[0], cz[1]);
                        var g = new SMap.Geometry(SMap.GEOMETRY_POLYLINE, null, coords);
                        vrstva.addGeometry(g);
                    }
                    var coords = [
                        SMap.Coords.fromWGS84(16.7096372, 49.6294364), // Jevicko
                        SMap.Coords.fromWGS84(15.4602619, 50.1544031), // Chlumec
                        SMap.Coords.fromWGS84(15.9935283, 50.4447586), // Hořičky
                        SMap.Coords.fromWGS84(16.0928944, 50.4762631), // Červený Kostelec
                        SMap.Coords.fromWGS84(15.8327683, 50.2092283), // Hradec Kralove
                        SMap.Coords.fromWGS84(17.2508706, 49.5938686), // Olomouc
                        SMap.Coords.fromWGS84(14.4341414, 50.0835494), // Praha
                        SMap.Coords.fromWGS84(14.2967675, 50.1962011), // Kozinec
                        SMap.Coords.fromWGS84(-118.485832, 34.003342), // Los Angeles
                        SMap.Coords.fromWGS84(14.2046206, 50.5996689), // Trebusin
                    ];
                    SMap.Route.route(coords, {
                        geometry: true
                    }).then(nalezeno);


                    // Markers
                    var obrazek = "https://api.mapy.cz/img/api/marker/drop-red.png";
                    var markersLayer = new SMap.Layer.Marker();
                    var markers = [{
                        name: "Jevíčko",
                        id: 1,
                        coord: SMap.Coords.fromWGS84(16.7123675, 49.6325497)
                    },{
                        name: "Třebušín",
                        id: 2,
                        coord: SMap.Coords.fromWGS84(14.2046206, 50.5996689)
                    }];


                    coords.push(SMap.Coords.fromWGS84(-118.485832, 34.003342))
                    markers = coords.map(c => ({name: c, id: c, coord: c}));

                    markers.forEach( ({coord, id, name}) => {
                        const marker = new SMap.Marker(coord, id, {title: name});
                        var card = new SMap.Card();
                        card.getHeader().innerHTML = `<strong>${name}</strong>`;
                        card.getBody().innerHTML = `XXX km`;
                        marker.decorate(SMap.Marker.Feature.Card, card);
                        markersLayer.addMarker(marker);
                    })
                    m.addLayer(markersLayer);
                    markersLayer.enable();


                    // URL
                    var smapUrl1 = new SMap.URL.Route().addStart(coords[0]).addDestination(coords[1]);
                    this.$nextTick(() =>
                        this.$refs.map.querySelector('.print').setAttribute('href', smapUrl1)
                    )

                    this.loading = false;
                });
            }
        },
        created() {
            const scriptUrl = 'https://api.mapy.cz/loader.js';
            const scriptElement = document.createElement('script');
            scriptElement.setAttribute('src', scriptUrl);
            scriptElement.addEventListener('load', this.initMap);
            document.head.appendChild(scriptElement);
            this.loading = true;
        }
    };
</script>

<style scoped>
    .map-content {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--v-secondary-lighten1);
        margin-bottom: 1rem;
    }
</style>